import styled from '@emotion/styled';
import React, { FC, useState } from 'react';
import NumberInput from '~ComponentsImproved/Numpad';
import { useButton, useCurrency, useI18n } from '~Hooks';
import { Button } from '~Styles';

export const StyledButton = styled(Button)`
  min-width: 104px;
  width: 104px;
  position: relative;
`;

const QuantityBadge = styled.span`
  position: absolute;
  bottom: 4px;
  left: 4px;
  font-size: 12px;
  font-weight: bold;
  pointer-events: none;
  color: var(--colorBlack);
  line-height: 1;
`;

interface Props {
  denomination: number;
  onSubmit: (denomination: number, quantity: number) => void;
  /** The quantity that has been entered for this denomination */
  quantity?: number;
}

/** Displays a button representing a denomination, if clicked shows a quantity input */
const DenominationButton: FC<Props> = ({ denomination, onSubmit, quantity = 0 }) => {
  const { i18n } = useI18n();
  const isHandy = window.innerWidth <= 600;
  const currency = useCurrency();

  const [showQuantityInput, setShowQuantityInput] = useState<boolean>(false);

  const btn = useButton({
    onClick: () => setShowQuantityInput(true),
  });

  return (
    <>
      <StyledButton padding="xs" {...btn}>
        {currency.format(denomination)}

        {quantity > 0 && <QuantityBadge>{quantity}</QuantityBadge>}
      </StyledButton>

      {showQuantityInput && (
        <NumberInput
          title={`${i18n('CashCounter.EnterQuantity')} ${currency.format(denomination)}`}
          onSubmit={(enteredQuantity) => {
            onSubmit(denomination, Number(enteredQuantity));
            setShowQuantityInput(false);
          }}
          onClose={() => setShowQuantityInput(false)}
          small={isHandy ? true : false}
        />
      )}
    </>
  );
};

export default DenominationButton;
